import type { FC } from 'react';

import { SvgIcon, type SvgIconProps } from '../SvgIcon';

export const VideoFormatSquareIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path
      d="M26 23L26 9C26 8.20435 25.6839 7.44129 25.1213 6.87868C24.5587 6.31607 23.7956 6 23 6L9 6C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9L6 23C6 23.7956 6.31607 24.5587 6.87868 25.1213C7.44129 25.6839 8.20435 26 9 26L23 26C23.7956 26 24.5587 25.6839 25.1213 25.1213C25.6839 24.5587 26 23.7956 26 23ZM9 24C8.73478 24 8.48043 23.8946 8.29289 23.7071C8.10536 23.5196 8 23.2652 8 23L8 9C8 8.73478 8.10536 8.48043 8.29289 8.29289C8.48043 8.10536 8.73478 8 9 8L23 8C23.2652 8 23.5196 8.10536 23.7071 8.29289C23.8946 8.48043 24 8.73478 24 9L24 23C24 23.2652 23.8946 23.5196 23.7071 23.7071C23.5196 23.8946 23.2652 24 23 24L9 24Z"
      fill="currentColor"
    />
  </SvgIcon>
);
